import { render, staticRenderFns } from "./PcVideo1.vue?vue&type=template&id=59ef1188&scoped=true"
import script from "./PcVideo1.vue?vue&type=script&lang=js"
export * from "./PcVideo1.vue?vue&type=script&lang=js"
import style0 from "./PcVideo1.vue?vue&type=style&index=0&id=59ef1188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ef1188",
  null
  
)

export default component.exports